var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useCallback } from 'react';
import { useLocation, useNavigationType, NavigationType } from 'react-router-dom';
import { EventEmitter } from '@ciceksepeti/cs-event-emitter';
import { getSessionData, setSessionData } from '@ciceksepeti/cs-session';
import { Session } from '@constants/session';
import Events from '@constants/events';
var ScrollRestoration = function () {
    var location = useLocation();
    var pathname = location.pathname;
    var state = location.state;
    var isBackButton = Boolean(state === null || state === void 0 ? void 0 : state.isBackButton);
    var navType = useNavigationType();
    var setScrollPosition = useCallback(function () {
        var _a;
        var scrollPositionsData = getSessionData(Session.SCROLL_POSITION);
        if (navType === NavigationType.Pop || isBackButton) {
            if (scrollPositionsData && scrollPositionsData[pathname]) {
                setTimeout(function () {
                    var _a;
                    window.scrollTo(0, scrollPositionsData[pathname]);
                    setSessionData(Session.SCROLL_POSITION, __assign(__assign({}, scrollPositionsData), (_a = {}, _a[pathname] = 0, _a)));
                }, 100);
            }
            else {
                window.scrollTo(0, 0);
            }
        }
        else {
            window.scrollTo(0, 0);
            if (scrollPositionsData && scrollPositionsData[pathname]) {
                setSessionData(Session.SCROLL_POSITION, __assign(__assign({}, scrollPositionsData), (_a = {}, _a[pathname] = 0, _a)));
            }
        }
    }, [isBackButton, navType, pathname]);
    var handleStoredDataLoad = useCallback(function () {
        setScrollPosition();
    }, [setScrollPosition]);
    useEffect(function () {
        var eventEmitter = new EventEmitter();
        eventEmitter.subscribe(Events.STORED_DATA_LOAD, handleStoredDataLoad);
        return function () {
            eventEmitter.unsubscribe(Events.STORED_DATA_LOAD, handleStoredDataLoad);
        };
    }, [handleStoredDataLoad]);
    useEffect(function () {
        if (history && history.scrollRestoration)
            history.scrollRestoration = 'manual';
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
export default ScrollRestoration;
